import { useHealthblocksSWR, useSubjectId } from '@healthblocks-io/core'

export function useInvoiceLink() {
  const subjectId = useSubjectId()
  return useHealthblocksSWR<{
    url?: string
    code?: 'auth_missing' | 'env_missing' | 'oazis_missing'
    message?: string
  }>(subjectId ? `/navigation/pom-invoice?subjectId=${subjectId}` : null).data
}

/**
 * The CMeal sign-in link for the patient. Resolving it costs a Synops call and a CMeal token
 * exchange on the server, so a screen that will not show the link passes `enabled: false`.
 */
export function useMealLink(enabled = true) {
  const subjectId = useSubjectId()
  return useHealthblocksSWR<{
    url?: string
    code?: 'auth_missing' | 'env_missing' | 'oazis_missing' | 'synops_error' | 'no_access'
    message?: string
  }>(enabled && subjectId ? `/navigation/meal?subjectId=${subjectId}` : null).data
}
